export enum DashboardActions {
  UPDATE_TAB_INDEX,
  UPDATE_DASHBOARD_TASKS,
  SET_SELECTED_TASKS,
  SET_SELECTED_DIALOG,
}
